<template>
<v-app>
  <div v-if="editedItem">
    <div class="ca_wrapper" >
      <div class="page page2">
        <div class="ca_header">
<!--          <div class="leftCA">【CA】</div>-->
          <table class="leftBox">
            <tr>
              <th width="50px">超優</th>
              <th width="45px">優質</th>
              <th width="50px">一般</th>
              <th width="45px">#</th>
            </tr>
            <tr>
              <td><input type="text"  v-model="editedItem.header.caseType5" @click="showCheckDialog(0)"
                         style="width:100%;" :disabled="checkCaseType" readonly></td>

<!--              <td><input type="text" v-model="editedItem.header.caseType" @click="showCheckDialog(0)"-->
<!--                         style="width:100%;" :disabled="checkCaseType" readonly></td>-->
              <td ><input type="text" style="width:100%;" v-model="editedItem.header.caseType4" :disabled="checkCaseType4" @click="showCheckDialog(1)" readonly></td>
              <td><span class="checkbox"><input type="checkbox" v-model="editedItem.header.caType[2].value" @click="checkCondition(2)"></span></td>
<!--              <td>-->
<!--                -->
<!--                <span class="checkbox"><input type="checkbox" v-model="editedItem.header.caType[0].value" @click="checkCondition(0)" :disabled="isDisablePlus"></span>-->
<!--              </td>-->
<!--              <td ><input type="text" style="width:100%;" v-model="editedItem.header.caseType5" @click="showCheckDialog5()" readonly></td>-->
<!--              <td ><input type="text" style="width:100%;" v-model="editedItem.header.caseType4" @click="showCheckDialog()" readonly></td>-->
              <td></td>
            </tr>
          </table>
          <h1>裕隆集團&nbsp;&nbsp;&nbsp;裕富數位資融股份有限公司<span class="h1s">2022.05&nbsp;通路版</span></h1>
          <h2>購物分期付款申請暨約定書</h2>
        </div><!--header-->
        <div class="blueBox blueBox1">
          <div class="tit">基本資料</div>
          <div class="date">
            申請日期：
            <select v-model="editedItem.applyDate.year">
              <option v-for="year in yearList" :key="year.key" :value="year.key">{{year.name}}</option>
            </select>年
            <select v-model="editedItem.applyDate.month">
              <option v-for="month in monthList" :key="month.key" :value="month.key">{{month.name}}</option>
            </select>月
            <select v-model="editedItem.applyDate.day">
              <option v-for="day in dayList" :key="day.key" :value="day.key">{{day.name}}</option>
            </select>日
          </div>
          <table class="blueTable blueTable1">
            <tr>
              <th width="45px">中&nbsp;文<br/>姓&nbsp;名</th>
              <td width="113px">
                <input type="text" v-model="editedItem.customer.name" placeholder="1.必填" style="width:100px">
              </td>
              <th width="48px">身分證<br/>字&nbsp;&nbsp;&nbsp;&nbsp;號</th>
              <td><input type="text" v-model="editedItem.customer.memberId" style="width:100px" placeholder="2.必填"></td>
            </tr>
            <tr>
              <th>出&nbsp;生<br/>日&nbsp;期</th>
              <td>
                <input type="text" v-model="editedItem.customer.birthday" placeholder="3.必填出生日" @click="showDateToolDialog('birthday')"
                      style="width:100px"/>
              </td>
              <th>婚&nbsp;姻<br/>狀&nbsp;況</th>
              <td>
                <div class="checkDiv"><span class="checkbox">
                                      <input type="checkbox" v-model="editedItem.customer.married[0].value"
                                            :checked="editedItem.customer.married[0].value === true"
                                      ></span>已婚
                </div>
                <div class="checkDiv"><span class="checkbox">
                                      <input type="checkbox" v-model="editedItem.customer.married[1].value"
                                            :checked="editedItem.customer.married[1].value === true"
                                      ></span>未婚
                </div>
                <br/>
                <div class="checkDiv"><span class="checkbox">
                                      <input type="checkbox" v-model="editedItem.customer.hasChild"
                                            :checked="editedItem.customer.hasChild"></span>子女
                  <input type="number" v-model="editedItem.customer.childCount"
                        style="width:25px; line-height:13px; height:13px; text-align:center">人
                </div>
              </td>
            </tr>
          </table><!--blueTable1-->
          <table class="blueTable blueTable2">
            <tr>
              <th width="45px">身分證<br/>初補換</th>
              <td width="163px">
                <div class="checkDiv">
                          <span class="checkbox"><input type="checkbox"
                                                        v-model="editedItem.customer.memberIdType[0].value"
                                                        :checked="editedItem.customer.memberIdType[0].value === true"></span>初發<br/><span
                  class="checkbox"><input type="checkbox" v-model="editedItem.customer.memberIdType[1].value"
                                          :checked="editedItem.customer.memberIdType[1].value === true"></span>補發<br/><span
                  class="checkbox"><input type="checkbox" v-model="editedItem.customer.memberIdType[2].value"
                                          :checked="editedItem.customer.memberIdType[2].value === true"></span>換發
                </div>
                <div class="date2">
                  <input type="text" placeholder="4.必填" v-model="editedItem.customer.memberIdDate"
                        @click="showDateToolDialog('memberIdDate')" style="width:100px"/>
                </div>
              </td>
              <th width="48px">發&nbsp;證<br/>地&nbsp;點</th>
              <td>
                <!-- <input type="text" placeholder="5.必填" v-model="editedItem.customer.memberIdCity"
                        style="width:100px"> -->
                <select v-model="editedItem.useCase.issue_place" style="width:100px;" @change="setMemberIdCity(1)">
                    <option v-for="cityItem in cityList" :key="cityItem.key" :value="cityItem.key">{{cityItem.name}}</option>
                </select>
              </td>
            </tr>
          </table><!--blueTable2-->
          <table class="blueTable blueTable3">
            <tr>
              <th width="45px">戶&nbsp;籍<br/>電&nbsp;話</th>
              <td width="115px" class="td-phone">
                <div class="checkDiv">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.customer.hasPhone"></span>無
                </div>
                <input type="text" placeholder="6.填寫加分" v-model="editedItem.customer.phone"
                      style="width:100px; margin-top:6px;">
              </td>
              <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv">
                  <span class="checkbox"><input type="checkbox" placeholder="7.填寫加分"
                                                v-model="editedItem.customer.hasHomePhone"></span>無
                </div>
                <input type="text" v-model="editedItem.customer.homePhone" style="width:100px; margin-top:6px;">
                <div :class="`btn-s btn-s1 ${editedItem.customer.isSecret ? 'btn-s-active':''}`">
                  <a href="#" target="_self"
                    @click.prevent="editedItem.customer.isSecret = !editedItem.customer.isSecret">保密</a>
                </div>
              </td>
            </tr>
            <tr>
              <th>行&nbsp;動<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.customer.hasCellphone"></span>無
                </div>
                <input type="text" placeholder="8.必填" v-model="editedItem.customer.cellphone"
                  onKeyUp="value=value.replace(/\D/g,'')"
                      onchange="value=value.replace(/\D/g,'')"
                      maxlength="11"
                      style="width:100px; margin-top:6px;">
              </td>
              <th>教&nbsp;育<br/>程&nbsp;度</th>
              <td>
                <div class="checkDiv checkDiv3">
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[0].value"></span>博士
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[1].value"></span>碩士
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[2].value"></span>大學
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[3].value"></span>專科
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[4].value"></span>高中職
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[5].value"></span>其他
                </div>
              </td>
            </tr>
            <tr>
              <th>戶&nbsp;籍<br/>地&nbsp;址</th>
              <td colspan="3">
                <input type="text" style="width:25px; height:26px; line-height:12px; display:inline;float:left;margin-right:5px"
                v-model="editedItem.customer.home.residencePost"
                                      onKeyUp="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')"
                                      onchange="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')">
                <textarea style="width:50px; height:26px; line-height:12px; padding:0;" placeholder="縣市"
                                      v-model="editedItem.customer.home.residenceCity"
                                      v-on:change="changeResidenceInfo"
                                      v-on:keyup="changeResidenceInfo"
                                      ></textarea>
                            <textarea style="width:50px; height:26px; line-height:12px; padding:0;" placeholder="區鄉鎮"
                                      v-model="editedItem.customer.home.residenceArea"
                                      v-on:change="changeResidenceInfo"
                                      v-on:keyup="changeResidenceInfo"
                                      ></textarea>
                            <textarea style="width:150px; height:26px; line-height:12px; padding:0;" placeholder="地址"
                                      v-model="editedItem.customer.home.residenceAddress"
                                      onKeyUp="value=value.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')"
                                      onchange="value=value.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')"
                                      ></textarea>
                <!-- <textarea style="width:280px; height:26px; line-height:12px; padding:0; " placeholder="9.填寫加分"
                              v-model="editedItem.customer.home.residenceAddress"></textarea> -->
              </td>
            </tr>
            <tr>
              <th>住&nbsp;宅<br/>地&nbsp;址</th>
              <td colspan="3" class="td-address4">
                <div class="checkDiv checkDiv4">
                  <span class="checkbox">
                    <input type="checkbox"
                                                v-model="editedItem.customer.home.homeType1[0].value"
                                                @change="checkHomeType"></span>同戶籍
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.homeType1[1].value"></span>另列如下
                </div>
                <input type="text" style="width:25px; height:26px; line-height:12px; display:inline;float:left;margin-right:5px"
                                      v-model="editedItem.customer.home.homePost"
                                      onKeyUp="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')"
                                      onchange="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')">

                <textarea style="width:50px; height:26px; line-height:12px; padding:0;" placeholder="縣市"
                        v-model="editedItem.customer.home.homeCity"
                        v-on:change="changeHomeInfo"
                        v-on:keyup="changeHomeInfo"
                        ></textarea>
              <textarea style="width:50px; height:26px; line-height:12px; padding:0;" placeholder="區鄉鎮"
                        v-model="editedItem.customer.home.homeArea"
                        v-on:change="changeHomeInfo"
                        v-on:keyup="changeHomeInfo"
                        ></textarea>
              <textarea style="width:150px; height:26px; line-height:12px; padding:0;" placeholder="地址"
                        v-model="editedItem.customer.home.homeAddress1"
                        onKeyUp="value=value.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')"
                        onchange="value=value.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')"
                        ></textarea>

                <!-- <textarea style="width:280px; height:26px; line-height:12px; padding:0;" placeholder="10.填寫加分"
                          v-model="editedItem.customer.home.homeAddress1"></textarea> -->
              </td>
            </tr>
            <tr>
              <th>居&nbsp;住<br/>時&nbsp;間</th>
              <td>
                <div class="date3">
                  <input type="text" v-model="editedItem.customer.home.liveYear" style="width:35px; text-align:center">年
                  <input type="text" v-model="editedItem.customer.home.liveMonth" style="width:35px; text-align:center">月
                </div>
              </td>
              <th>居&nbsp;住<br/>狀&nbsp;況</th>
              <td>
                <div class="checkDiv checkDiv5">
                            <span class="checkbox"><input type="checkbox"
                                                          v-model="editedItem.customer.home.liveLevel[0].value"></span>本人名下
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[1].value"></span>配偶名下<br/>
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[2].value"></span>親友
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[3].value"></span>租賃
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[4].value"></span>宿舍
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[5].value"></span>其他
                </div>
              </td>
            </tr>
            <tr>
              <th>繳&nbsp;款<br/>方&nbsp;式</th>
              <td colspan="3" class="td-address6">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.customer.usePhonePayment"></span>簡訊條碼繳款
                </div>
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.customer.useElectronicBill"></span>電子帳單(請填E-mail)
                </div>
                <br/>
                <input type="text" v-model="editedItem.customer.paymentEmail" style="width:267px;">
              </td>
            </tr>
            <tr>
              <th>E-mail</th>
              <td colspan="3" class="td-email">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.customer.hasMail"></span>無
                </div>
                <input type="text" placeholder="11.填寫加分" v-model="editedItem.customer.email" style="width:267px;">
              </td>
            </tr>
          </table><!--blueTable3-->
        </div><!--blueBox1-->
        <div class="blueBox blueBox2">
          <div class="tit">職業資料</div>
          <div class="contact">
  <!--          服務電話：(02)2702-5055&nbsp;#3<br/>-->
  <!--          案件傳真：(02)2700-3559-->
          </div>
          <table class="blueTable blueTable4">
            <tr>
              <th width="48px">公&nbsp;司<br/>名&nbsp;稱</th>
              <td width="135px" class="td-com">
                <div class="checkDiv">
                                  <span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.company.type[0].value"></span>無<span
                  class="checkbox">
                                      <input type="checkbox" v-model="editedItem.company.type[1].value"></span>家管<span
                  class="checkbox">
                                      <input type="checkbox" v-model="editedItem.company.type[2].value"></span>另列如下
                </div>
                <input type="text" placeholder="12.必填" v-model="editedItem.company.name"
                      style="width:125px; margin-top:6px;">
              </td>
              <th width="48px">公&nbsp;司<br/>電&nbsp;話</th>
              <td class="td-phone">
                <!-- <div class="checkDiv">
                                  <span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.company.hasPhone"></span>無
                </div> -->
                <input type="text" placeholder="區碼" v-model="editedItem.company.areaCode"
                    onKeyUp="value=value.replace(/\D/g,'')"
                    onchange="value=value.replace(/\D/g,'')"
                    maxlength="3"  style="width:30px;">
                <input type="text" placeholder="13.必填" v-model="editedItem.company.phone"
                    onKeyUp="value=value.replace(/\D/g,'')"
                    onchange="value=value.replace(/\D/g,'')"
                    maxlength="11" style="width:70px;">
                <div :class="`btn-s btn-s2 ${editedItem.company.isSecret ? 'btn-s-active':''}`">
                  <a href="#" target="_self" @click.prevent="editedItem.company.isSecret = !editedItem.company.isSecret">保密</a>
                </div>
              </td>
            </tr>
            <tr>
              <th>公&nbsp;司<br/>地&nbsp;址</th>
              <td class="td-address" colspan="3">
                <div class="checkDiv">
                                  <span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.company.hasAddress"></span>無
                </div>
                <textarea style="width:300px; height:24px; line-height:12px; padding:0; margin-bottom:-2px;"
                          placeholder="14.填寫加分"
                          v-model="editedItem.company.address"></textarea>
              </td>
            </tr>
          </table><!--blueTable4-->
          <table class="blueTable blueTable5">
            <tr>
              <th width="48px">職稱</th>
              <td width="90px"><input type="text" placeholder="15.填寫加分" v-model="editedItem.company.title"
                                      style="width:80px;"></td>
              <th width="35px">年資</th>
              <td width="73px">
                <div class="date4">
                  <input type="text" v-model="editedItem.company.workYear"
                        style="width:17px; text-align:center; padding:0">年
                  <input type="text" v-model="editedItem.company.workMonth"
                        style="width:17px; text-align:center; padding:0">月
                </div>
              </td>
              <th width="33px">月薪</th>
              <td><input type="text" placeholder="16.填寫加分" v-model="editedItem.company.salary" style="width:60px;">元</td>
            </tr>
          </table><!--blueTable5-->
          <div class="blueBox blueBox3">
            <div class="tit">銀行資料</div>
            <div class="checkDiv"><span class="checkbox">
              <input type="checkbox" v-model="editedItem.bank.type[0].value" @change="checkCreditcardStatus(0)"></span>沒辦過卡
            </div>
            <div class="checkDiv"><span class="checkbox">
              <input type="checkbox" v-model="editedItem.bank.type[1].value" @change="checkCreditcardStatus(1)"></span>無卡自停
            </div>
            <div class="checkDiv"><span class="checkbox">
              <input type="checkbox" v-model="editedItem.bank.type[2].value" @change="checkCreditcardStatus(2)"></span>協商繳款中
            </div>
            <div class="checkDiv"><span class="checkbox">
              <input type="checkbox" v-model="editedItem.bank.type[3].value" @change="checkCreditcardStatus(3)"></span>其他：
              <input type="text" v-model="editedItem.bank.otherType" style="width:50px;" v-on:input="setOtherType">
            </div>
            <table class="blueTable blueTable6">
              <tr>
                <th width="48px">發&nbsp;卡<br/>銀&nbsp;行</th>
                <td width="125px"><input type="text" placeholder="17.填寫加分" v-model="editedItem.bank.name"
                                        style="width:110px;"></td>
                <th width="50px">有&nbsp;效<br/>日&nbsp;期</th>
                <td>
                  <div class="date5">
                    <input type="text" v-model="editedItem.bank.effectiveMonth"
                          style="width:45px; text-align:center">月
                    <input type="text" v-model="editedItem.bank.effectiveYear"
                          style="width:45px; text-align:center">年
                  </div>
                </td>
              </tr>
              <tr>
                <th>卡號</th>
                <td colspan="3" class="cardNb"><input type="text" placeholder="18.填寫加分"
                                                      v-model="editedItem.bank.creditCard"
                                                      style="width:150px; "><span
                  class="ps">(請填寫本人正卡資料)</span></td>
              </tr>
            </table><!--blueTable6-->
          </div><!--blueBox3-->
          <div class="blueBox blueBox4">
            <div class="tit">聯絡人資料</div>
            <span class="titps">(請留一位與您不同居所的親屬，若無住家電話請留兩位聯絡人)</span>
            <table class="blueTable blueTable7">
              <tr>
                <th width="48px">中&nbsp;文<br/>姓&nbsp;名</th>
                <td width="110px"><input type="text" placeholder="19.必填" v-model="editedItem.firstContact.name"
                                        @click="showTip"
                                        style="width:100px; "></td>
                <th width="30px">關係</th>
                <td width="35px" class="text_c">
                  <select v-model="editedItem.firstContact.relationship" style="width:30px;" @change="setTypeEvent(1)">
                    <option v-for="relationship in relationshipList" :key="relationship.key" :value="relationship.key">{{relationship.name}}</option>
                  </select>
                  <!-- <input type="text" placeholder="20.必填"
                                                      v-model="editedItem.firstContact.type"
                                                      style="width:30px; ">-->
                </td>
                <th width="50px">行&nbsp;動<br/>電&nbsp;話</th>
                <td class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                      v-model="editedItem.firstContact.hasCellphone"></span>無</div>
                  <input type="text" placeholder="21.必填" v-model="editedItem.firstContact.cellphone"
                    onKeyUp="value=value.replace(/\D/g,'')"
                      onchange="value=value.replace(/\D/g,'')"
                      maxlength="11"
                        style="width:80px; margin-bottom:-2px; margin-top:-2px;">
                </td>
              </tr>
            </table><!--blueTable7-->
            <table class="blueTable blueTable8">
              <tr>
                <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
                <td width="140px" class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                      v-model="editedItem.firstContact.hasHomePhone"></span>無
                  </div>
                  <input type="text" placeholder="22.填寫加分" v-model="editedItem.firstContact.homePhone"
                        style="width:80px; margin-top:6px;">
                </td>
                <th width="35px">公&nbsp;司<br/>電&nbsp;話</th>
                <td class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                      v-model="editedItem.firstContact.hasCompanyPhone"></span>無
                  </div>
                  <input type="text" placeholder="23.填寫加分" v-model="editedItem.firstContact.companyPhone"
                        style="width:80px; margin-top:6px;">
                  <div :class="`btn-s btn-s3 ${editedItem.firstContact.isSecret ? 'btn-s-active':''}`">
                    <a href="#" target="_self"
                      @click.prevent="editedItem.firstContact.isSecret = !editedItem.firstContact.isSecret">保密</a>
                  </div>
                </td>
              </tr>
            </table><!--blueTable8-->
            <table class="blueTable blueTable9">
              <tr>
                <th width="48px">中&nbsp;文<br/>姓&nbsp;名</th>
                <td width="110px"><input type="text" placeholder="24.填寫加分" v-model="editedItem.secondContact.name"
                                        @click="showSecondTip"
                                        style="width:100px; "></td>
                <th width="30px">關係</th>
                <td width="35px" class="text_c">
                  <select v-model="editedItem.secondContact.relationship" style="width:30px;" @change="setTypeEvent(2)">
                    <option v-for="relationship in relationshipList" :key="relationship.key" :value="relationship.key">{{relationship.name}}</option>
                  </select>
                  <!-- <input type="text" placeholder="25.必填"
                                                      v-model="editedItem.secondContact.type"
                                                      style="width:30px; "> -->
                </td>
                <th width="50px">行&nbsp;動<br/>電&nbsp;話</th>
                <td class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                      v-model="editedItem.secondContact.hasCellphone"></span>無
                  </div>
                  <input type="text" placeholder="26.填寫加分" v-model="editedItem.secondContact.cellphone"
                    onKeyUp="value=value.replace(/\D/g,'')"
                      onchange="value=value.replace(/\D/g,'')"
                      maxlength="11"
                        style="width:80px; margin-bottom:-2px; margin-top:-2px;">
                </td>
              </tr>
            </table><!--blueTable9-->
            <table class="blueTable blueTable10">
              <tr>
                <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
                <td width="140px" class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                      v-model="editedItem.secondContact.hasHomePhone"></span>無
                  </div>
                  <input type="text" placeholder="27.填寫加分" v-model="editedItem.secondContact.homePhone"
                        style="width:80px; margin-top:6px;">
                </td>
                <th width="35px">公&nbsp;司<br/>電&nbsp;話</th>
                <td class="td-phone">
                  <input type="text" placeholder="28.填寫加分" v-model="editedItem.secondContact.companyPhone"
                        style="width:80px;">
                  <div :class="`btn-s btn-s4 ${editedItem.secondContact.isSecret ? 'btn-s-active':''}`">
                    <a href="#" target="_self"
                      @click.prevent="editedItem.secondContact.isSecret = !editedItem.secondContact.isSecret">保密</a>
                  </div>
                </td>
              </tr>
            </table><!--blueTable10-->
          </div><!--blueBox4-->
        </div><!--blueBox2-->
        <div class="redBox">
          <div class="ps" style="width: 835px">※以下欄位資料為：
            <div class="checkDiv">1.<span class="checkbox">
                          <input type="checkbox" v-model="editedItem.hasJointGuarantor[0].value"></span>連帶保證人(需附保證人身分證正反面影本及簽名)
            </div>
            <div class="checkDiv">2.<span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.hasJointGuarantor[1].value"></span>配偶資料僅供參考
            </div>
            <div class="checkDiv">3.<span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.hasJointGuarantor[2].value"></span>法定代理人(須於法代欄位簽名)
            </div>
            <div class="checkDiv">4.<span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.hasJointGuarantor[3].value"></span>商品實際使用人
            </div>
          </div>
          <table class="redTable">
            <tr>
              <th width="48px">姓&nbsp;名</th>
              <td width="160px"><input type="text" v-model="editedItem.jointGuarantor.name"
                                      style="width:100px; "></td>
              <th width="55px">關&nbsp;係</th>
              <td width="83px">
                <select v-model="editedItem.jointGuarantor.relationship" style="width:70px;" @change="setTypeEvent(3)">
                    <option v-for="relationship in relationshipList" :key="relationship.key" :value="relationship.key">{{relationship.name}}</option>
                  </select>
                <!-- <input type="text" v-model="editedItem.jointGuarantor.type"
                                      style="width:70px; "> -->
              </td>
              <th width="48px">身分證<br/>字&nbsp;&nbsp;號</th>
              <td width="153px"><input type="text" v-model="editedItem.jointGuarantor.memberId"
                                      style="width:100px; "></td>
              <th width="48px">出&nbsp;生<br/>日&nbsp;期</th>
              <td>
                <div class="date6">
                  <input type="text" v-model="editedItem.jointGuarantor.birthday"
                        @click="showDateToolDialog('jointGuarantor.birthday')" style="width:100px; ">
                </div>
              </td>
            </tr>
            <tr>
              <th>身分證<br/>初補換</th>
              <td>
                <div class="checkDiv">
                            <span class="checkbox"><input type="checkbox"
                                                          v-model="editedItem.jointGuarantor.memberIdType[0].value"></span>初發<br/>
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.jointGuarantor.memberIdType[1].value"></span>補發<br/>
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.jointGuarantor.memberIdType[2].value"></span>換發
                </div>
                <div class="date7">
                  <input type="text" v-model="editedItem.jointGuarantor.memberIdDate"
                        @click="showDateToolDialog('jointGuarantor.memberIdDate')"
                        style="width:100px; margin-top:-10px;">
                </div>
              </td>
              <th>發&nbsp;證<br/>地&nbsp;點</th>
              <td>
                <!-- <input type="text" v-model="editedItem.jointGuarantor.memberIdCity" style="width:70px; "> -->
                <select v-model="editedItem.useCase.guarantor_issue_place" style="width:100px;" @change="setMemberIdCity(2)">
                    <option v-for="cityItem in cityList" :key="cityItem.key" :value="cityItem.key">{{cityItem.name}}</option>
                </select>
              </td>
              <th>住&nbsp;家<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.jointGuarantor.hasHomePhone"></span>無
                </div>
                <input type="text" v-model="editedItem.jointGuarantor.homePhone"
                      style="width:80px; margin-top:3px; margin-bottom:-5px">
              </td>
              <th>行&nbsp;動<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.jointGuarantor.hasCellphone"></span>無
                </div>
                <input type="text" v-model="editedItem.jointGuarantor.cellphone"
                      style="width:80px; margin-top:3px; margin-bottom:-5px">
              </td>
            </tr>
            <tr>
              <th>公&nbsp;司<br/>名&nbsp;稱</th>
              <td colspan="3"><input type="text" v-model="editedItem.jointGuarantor.companyName"
                                    style="width:200px;"></td>
              <th>職&nbsp;稱</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.jointGuarantor.hasTitle"></span>無
                </div>
                <input type="text" v-model="editedItem.jointGuarantor.title"
                      style="width:80px; margin-top:3px; margin-bottom:-5px">
              </td>
              <th>公&nbsp;司<br/>電&nbsp;話</th>
              <td class="td-phone">
<!--                <div class="checkDiv"><span class="checkbox"><input type="checkbox"-->
<!--                                                                    v-model="editedItem.jointGuarantor.hasCompanyPhone"></span>無-->
<!--                </div>-->
                <input type="text" placeholder="區碼" v-model="editedItem.jointGuarantor.companyTelCode" onKeyUp="value=value.replace(/\D/g,'')"
                       onchange="value=value.replace(/\D/g,'')"
                       maxlength="3" style="width:30px;">
                <input type="text" v-model="editedItem.jointGuarantor.companyPhone"
                      style="width:35px; margin-top:3px;">
                <span class="ext">分機
                  <input type="text" v-model="editedItem.jointGuarantor.companySubPhone"
                                             style="width:20px; margin-bottom:-5px;"></span>
              </td>
            </tr>
          </table><!--redTable-->
        </div><!--redBox-->
        <div class="yBox">
          <div class="ps">
            <div class="checkDiv"><span class="checkbox">
                          <input type="checkbox" v-model="editedItem.caseInfo.type[0].value"></span>新件
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.type[1].value"></span>補保人
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.type[2].value"></span>補資料
            </div>
            」「
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.interestRate[0].value"></span>零利率
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.interestRate[1].value"></span>低利率
            </div>
            」「
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.category[0].value"></span>ㄧ般件
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.category[1].value"></span>保密件
            </div>
            」
          </div>
          <div class="tit">經&nbsp;&nbsp;銷&nbsp;&nbsp;商&nbsp;&nbsp;填&nbsp;&nbsp;寫&nbsp;&nbsp;欄</div>
          <table class="yTable1">
            <tr class="yTr">
              <th width="20px" rowspan="2">分期內容</th>
              <th width="110px">商品名稱</th>
              <th width="73px" class="psTh1">頭款<span>(訂金)</span></th>
              <th width="65px">商品總價</th>
              <th width="155px" class="psTh2">辦理分期金額<span>(商品總價-已付頭款)</span></th>
              <th width="45px">期數</th>
              <th width="130px" class="psTh3">每期應繳金額<span>(期付款)</span></th>
              <th class="psTh4">分期總額<span>(期數X期付金額)</span></th>
            </tr>
            <tr>
              <td><input type="text" v-model="editedItem.vendor.productName" style="width:90px; text-align:center"></td>
              <td>
                <!-- <input type="text" v-model="editedItem.vendor.deposit"
                                  style="width:50px; text-align:center"/> -->
              </td>
              <td>
<!--                <input type="text" v-model="editedItem.vendor.totalPrice"-->
<!--                  @change="changeInstallmentsNumber"-->
<!--                  style="width:50px; text-align:center"/>-->
                <input type="text" v-model="editedItem.vendor.totalPrice"
                       v-if="canCustomPrice"
                       @change="changeInstallmentsNumber"
                       style="width:50px; text-align:center"/>
                <select v-else v-model="editedItem.vendor.totalPrice" style="width:50px; text-align:center"
                        @change="changeInstallmentsNumber">
                  <option v-for="price in getCreditPriceList" :key="price" :value="price">
                    {{price}}
                  </option>
                </select>
              </td>
              <td>
  <!--              <input type="text" value="150,000" style="width:140px; text-align:center">-->
              </td>
              <td>
                <input type="text" v-model="editedItem.vendor.installmentsNumber"
                      v-if="canCustomPrice"
                       @change="changeInstallmentsNumber"
                      style="width:50px; text-align:center"/>
                <select v-else v-model="editedItem.vendor.installmentsNumber" style="width:30px; text-align:center"
                        @change="changeInstallmentsNumber">
                  <option v-for="number in getInstallmentsNumberList" :key="number" :value="number">{{number}}</option>
                </select>
              </td>
              <td><input type="number" v-model="editedItem.vendor.creditPriceMonth"
                         style="width:110px; text-align:center"></td>
              <td>
                <input v-if="canCustomPrice" type="number" v-model="editedItem.vendor.totalCreditPrice" style="width:110px; text-align:center">
                <span v-else>{{editedItem.vendor.totalCreditPrice}}</span>
              </td>
            </tr>
          </table><!--yTable1-->
          <table class="yTable2">
            <tr>
              <th width="70px">
                <span class="th1">經銷商或<br/>債權讓與人名稱<br/>(約定受款方)</span></th>
              <td width="133px">
  <!--              <input type="text" value="名稱" style="width:100px;">-->
              </td>
              <th width="65px">
                <span class="th2">經銷商或<br/>債權讓與人<br/>電話</span>
              </th>
              <td width="105px" class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.vendor.hasCellphone"
                                                                    disabled></span>無電話請打手機聯絡
                </div>
              </td>
              <th width="50px">
                <span class="th3">經銷商或<br/>債權讓與人<br/>傳真</span>
              </th>
              <td width="110px" class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" v-model="editedItem.vendor.hasFax"
                                                                    disabled></span>無傳真請電話通知
                </div>
              </td>
              <th rowspan="3" class="sign1">
                <span class="bg"></span>
                <span class="txt">(請蓋公司大小章或發票章)</span>
                <span class="ps">※債權轉讓確認章<br/>※遲延利息及委約金之請求權同意一併讓與受讓人</span>
              </th>
            </tr>
            <tr>
              <th>經辦店名稱</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" v-model="editedItem.vendor.sameVendor"
                                                                    disabled></span>同經銷商或債權讓與人
                </div>
              </td>
              <th>經辦店<br/>電&nbsp;&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.vendor.hasSalesPhone"
                                                                    disabled></span>無電話請打手機聯絡
                </div>
              </td>
              <th>經辦人<br/>手&nbsp;&nbsp;機</th>
              <td><input type="text" v-model="editedItem.vendor.salesCellphone" style="width:80px; "></td>
            </tr>
            <tr>
              <td colspan="6" class="td-phone td-phone2">

                <div class="checkDiv checkDiv2">
                  經銷商備註欄：<br/>
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.vendor.type[0].value"></span>熟客&nbsp;
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.vendor.type[1].value"></span>過路客&nbsp;
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.vendor.type[2].value"></span>指定照會時間：<span
                  class="m"><input
                  type="text" v-model="editedItem.vendor.checkTime.month" style="width:20px; margin-bottom:-5px "></span>月<span
                  class="d"><input type="text" v-model="editedItem.vendor.checkTime.day"
                                  style="width:20px; margin-bottom:-5px "></span>日<span
                  class="t"><input type="text" value="" style="width:20px; margin-bottom:-5px "></span>午<span
                  class="h"><input type="text" v-model="editedItem.vendor.checkTime.hour"
                                  style="width:20px; margin-bottom:-5px "></span>點<span
                  class="min"><input type="text" v-model="editedItem.vendor.checkTime.minute"
                                    style="width:20px; margin-bottom:-5px "></span>分
                </div>
                <span class="ps2"><input type="text" v-model="editedItem.vendor.comment"
                                        style="width:320px; padding:0; height:12px;" placeholder="備註"></span>
                <div class="sign2">
                  經辦人簽名
                  <span class="bg"><input type="text" v-model="editedItem.vendor.signature"
                                          style="width:85px; padding:0; height:15px;"></span>
                  <span class="txt">本人證實申請人及連帶保證人身分正確並親自簽章無誤</span>
                </div>
              </td>
            </tr>
          </table><!--yTable2-->
        </div><!--yBox-->
        <div class="gTit">約定事項</div>
        <div class="gContent">
          <ul class="gBoxCon">
            申請人（以下簡稱甲方）及其連帶保證人、經銷商或債權讓與人（以下簡稱乙方）及債權受讓人裕富數位資融（股）公司（以下簡稱裕富公司）三方同意訂定本購物分期付款申請暨約定書（以下簡稱本約定書），<span
            class="redHighlight">其個別商議及特別授權之約定事項如下：</span><br/>
            <li>
              甲方及其連帶保證人同意裕富公司得將甲方及其連帶保證人與裕富公司往來本契約之相關資料（包括但不限於基本資料、信用資料、財務資料等），提供予財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依其設立目的、章程及相關法令規定，蒐集、處理及利用甲方及其連帶保證人之資料，並已暸解及同意裕富公司及財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依個人資料保護法規定所告知之事項。財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依其設立目的、章程及相關法令規定，得將本人資料提供與其參與徵信資料交換及利用之會員、融資租賃業、金融目的事業主管機關及其他依法令得蒐集、處理及利用資料之人。甲方及其連帶保證人確認已受個人資料保護法第三條、第八條及第九條告知且留存本約定書繕本，得憑之主張相關權利。
            </li>
            <li>
              甲方及其連帶保證人同意裕富公司得於履行契約及商品推廣、市場調查、數據分析之目的範圍內，依個人資料保護法相關規定以電腦蒐集、處理、利用甲方及其連帶保證人提供之前述基本資料（不包括財團法人金融聯合徵信中心及中華徵信所企業股份有限公司查詢之信用資料），並向相關之個人、機關、法人等查詢該等資料及往來紀錄，亦同意裕富公司得將前述往來之資料，提供予（一）受讓（或擬受讓）裕富公司債權之債權人，（二）受裕富公司委任代為處理事務之人或與裕富公司有簽約之委外合作廠商，（三）裕富公司之分公司，（四）裕隆汽車製造（股）公司及其相關企業／裕融企業及其關係企業，（五）財團法人金融聯合徵信中心，（六）逾期催收之受託公司（限甲方及其連帶保證人違約時）。但甲方及其連帶保證人得隨時要求停止對其相關資料交互運用。<span
              class="redHighlight">申請人就本項約定：<div class="checkDiv"><span class="checkbox"><input
              type="checkbox" v-model="editedItem.agree[0].value"></span>同意</div><div
              class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                             v-model="editedItem.agree[1].value"></span>不同意</div>（若未勾選視為不同意）；連帶保證人就本項約定：
                            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                                v-model="editedItem.agree[2].value"></span>同意</div><div
                class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                               v-model="editedItem.agree[3].value"></span>不同意</div>（若未勾選視為不同意）</span>
            </li>
            <li>
              甲方及其連帶保證人已受說明／告知本約定書重要內容及相關權利義務，並已充分暸解本約定書之重要內容及相關權利義務，且同意乙方或裕富公司得修正本約定書（共二頁）所填資料，並同意申請時所提供之資料及本約定書正本不予退還。
            </li>
            <li>甲方及其連帶保證人已攜回本約定書審閱，並經給予五日以上之期間詳閱並充分了解本契約之全部條款後簽訂本約定書。</li>
            <li>
              甲方及其連帶保證人於簽約時已充分暸解並同意，乙方將請求支付分期價款之權利及依本約定書約定所得享受之其他一切權利及利益（含延遲利息及違約金）讓與裕富公司，裕富公司並依約付款予乙方或撥入「指示付款同意暨約定書」所指定之帳戶以為收買應收帳款之債權。甲方及其連帶保證人並於裕富公司依約為上述撥付款項時即為知悉債權讓與事實，並應依約繳款予裕富公司。
            </li>
            <li>分期價金還款方式與內容：本分期依經銷商填寫欄內容自撥款日次月起每月一期，依年金計法計算，按月平均攤還本息予裕富公司。</li>
            <li>甲方申辦之機車分期付款業務，車牌號碼：<input type="text" v-model="editedItem.carInfo.carId" style="width:100px">；甲方同意將前述車輛車牌領牌登記於二等親屬（姓名：<input
              type="text" v-model="editedItem.carInfo.name" style="width:100px">、身分證字號：<input type="text"
                                                                                                   v-model="editedItem.carInfo.memberId"
                                                                                                   style="width:100px">、與甲方關係為
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[0].value"></span>本人之父／母
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[1].value"></span>子／女
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[2].value"></span>兄／弟
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[3].value"></span>姊／妹
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[4].value"></span>祖父／母
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[5].value"></span>外祖父／母
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[6].value"></span>孫／孫女／外孫／外孫女
              </div>
              ）之名下（並檢附證明），全部分期付款概由甲方負責。
            </li>
            <li>
              甲方及其連帶保證人同意特別授權如下：（一）甲方及其連帶保證人同意裕富公司將款項撥入甲方與乙方所指定之帳戶時，授權裕富公司及其指定人填載本票發票日（即撥款日）及本票金額（即分期總額）、付款地，甲方及其連帶保證人絕無異議。（二）甲方及其連帶保證人倘有違反本約定書任一條款或延遲繳納分期款項時，甲方及其連帶保證人均授權裕富公司及其指定人得不經過通知逕行填載本票到期日，並主張票據權利。(三) 本票供為分期付款買賣之分期款項總項憑證，俟分期付款完全清償完畢時，本票自動失效，但如有一期未付，發票人就全部本票債務負責清償。<br/><span
              class="redHighlight">※***甲方、甲方之法定代理人及甲方之連帶保證人確認已充分詳閱及了解並同意本約定書及其個別商議及特別授權之約定事項各款內容並確認簽章：</span>
            </li>
          </ul><!--gBoxCon-->
        </div><!--約定事項gContent-->
        <div class="signBlue">
          甲方<span class="s">(申請人)</span><br/>
          簽&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名
  <!--        <span class="box"></span>-->
          <img class="box" :src="signImageSrc('signImage1')"/>
          <div class="box"
              style="z-index: 100; background: transparent; border: transparent 1px;" type="text"
              @click="showSignDialog('customer')"></div>
        </div>
        <div class="signRed">
          甲&nbsp;方&nbsp;連&nbsp;帶<br/>
          保證人簽章
  <!--        <span class="box"></span>-->
          <img class="box" :src="signImageSrc('signImage3')"/>
          <div class="box"
              style="z-index: 100; background: transparent; border: transparent 1px;" type="text"
              @click="showSignDialog('jointGuarantor')"></div>
        </div>
        <div class="signGreen">
          甲&nbsp;方&nbsp;法&nbsp;定<br/>
          代理人簽名
          <span class="box"></span>
          <span class="box2"></span>
        </div>
        <div class="dot"><span>(續下頁)</span></div>
        <div class="bottomTit">&#9826本票</div>
        <div class="bottomCon">
          憑票於中華民國<input type="text" v-model="editedItem.promisedNote.promisedDate.year"
                        style="width:40px; text-align:center; height:16px; margin:0 3px;">年<input type="text"
                                                                                                  v-model="editedItem.promisedNote.promisedDate.month"
                                                                                                  style="width:40px; text-align:center; height:16px; margin:0 3px;">月<input
          type="text" v-model="editedItem.promisedNote.promisedDate.day"
          style="width:40px; text-align:center; height:16px; margin:0 3px;">日無條件支付裕富數位資融股份有限公司<br/>
          新台幣<input type="text" v-model="editedItem.promisedNote.money.one"
                    style="width:75px; text-align:center; height:16px; margin:0 3px;">拾<input type="text"
                                                                                              v-model="editedItem.promisedNote.money.two"
                                                                                              style="width:75px; text-align:center; height:16px; margin:0 3px;">萬<input
          type="text" v-model="editedItem.promisedNote.money.three"
          style="width:75px; text-align:center; height:16px; margin:0 3px;">仟<input
          type="text" v-model="editedItem.promisedNote.money.four"
          style="width:75px; text-align:center; height:16px; margin:0 3px;">佰<input
          type="text" v-model="editedItem.promisedNote.money.five"
          style="width:75px; text-align:center; height:16px; margin:0 3px;">拾<input
          type="text" v-model="editedItem.promisedNote.money.six"
          style="width:75px; text-align:center; height:16px; margin:0 3px;">元整<span
          class="ps3">(本票金額可填大寫或阿拉伯數字，二擇一)</span>
          <span class="ps1">此本票免除做成拒絕證書及票據法第八十九條之通知義務，利息自到期日迄清償日止按年息百分之十六計付，發票人授權持票人得填載到期日。</span>
          <br/>
          付款地：<input type="text" v-model="editedItem.promisedNote.paymentCity"
                    style="width:100px; height:16px; margin:0 3px;"><br/>
          中華民國<input type="text" v-model="editedItem.promisedNote.createDate.year"
                    style="width:30px; text-align:center; height:16px; margin:0 3px;">年<input type="text"
                                                                                              v-model="editedItem.promisedNote.createDate.month"
                                                                                              style="width:25px; text-align:center; height:16px; margin:0 3px;">月<input
          type="text" v-model="editedItem.promisedNote.createDate.day"
          style="width:25px; text-align:center; height:16px; margin:0 3px;">日1.發票人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <img class="box1" :src="signImageSrc('signImage2')"/>
          <div class="box1"
              style="z-index: 100; background: transparent; border: transparent 1px;" type="text"
              @click="showSignDialog('invoiceSign')"></div>
          2.發票人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <img class="box2" :src="signImageSrc('signImage3')"/>
          <div class="box2"
              style="z-index: 100; background: transparent; border: transparent 1px;" type="text"
              @click="showSignDialog('jointGuarantor')"></div>
          3.發票人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span class="box3"></span>
          <div class="signAll">法定代理人：<span class="box4"></span><span class="box5"></span></div>
          <span class="ps2"></span>

        </div><!--bottomCon-->
      </div><!--page2-->

      <v-card v-if="(editedItem.fileList && editedItem.fileList.length)
      || (hasAttachmentFile)">
        <div class="pb-2 mb-2">
          <v-card-title>
            <span class="title">PDF檔 / Zip檔</span>
          </v-card-title>
          <v-layout ml-2 v-for="(file, i) in editedItem.fileList" :key="i">
            <v-flex ml-2>
              <a class="subheading" :href="file.data" target="_blank">
                {{file.imageName}}
              </a></v-flex>
          </v-layout>
          <v-layout v-if="hasAttachmentFile" ml-2
                    v-for="(file, i) in attachmentFile.attachmentFiles" :key="i">
            <v-flex ml-2>
              <a class="subheading" :href="file.url" target="_blank">
                {{file.fileName}}
              </a></v-flex>
          </v-layout>
        </div>
      </v-card>

      <use-case-view v-if="platform === 3"
        :item-detail="editedItem"
        @changeEvent="changeEvent"
        @uploadEvent="uploadEvent"
      ></use-case-view>

      <div class="btn">
        <span class="mr-2 subheading red--text" v-if="loadingInfo">案件上傳中 請勿關閉視窗</span>
        <v-btn class="primary center" dark text :loading="loadingInfo" @click="save">確認上傳</v-btn>
        <!-- <a href="" @click.prevent="save">確認上傳</a> -->
      </div>

       <v-dialog
      v-model="dateInfoDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title class="headline">
          {{dateInfoDialog.text}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap v-if="dateInfoDialog.key === 'birthday'">
            <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.birthdayInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field outlined v-model="editedItem.customer.birthdayInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field outlined v-model="editedItem.customer.birthdayInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
            </v-flex>
          </v-layout>

          <div v-if="dateInfoDialog.key === 'memberIdDate'">
            <v-layout row wrap>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="dateInfoDialog.key === 'jointGuarantor.birthday'">
            <v-layout row wrap>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="dateInfoDialog.key === 'jointGuarantor.memberIdDate'">
            <v-layout row wrap>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
              </v-flex>
            </v-layout>
          </div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text @click="dateInfoDialog.confirm">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog
        fullscreen hide-overlay
        v-model="signDialog.visible">
        <v-card>
          <v-card-text>
            <draw-canvas :visible="signDialog.visible" @handleDownloadSign="handleDownloadSign"  @closeEvent="handleDownloadClose"></draw-canvas>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!--提示-->
      <alert-view :visible="messageDialog.visible"
                  :title="messageDialog.title"
                  :content="messageDialog.text"
                  @confirmEvent="messageDialog.confirm">
                </alert-view>

      <!--申辦條件-->
      <v-dialog
        v-model="checkDialog.visible"
        :max-width="isMobile ? '90%':'50%'">
        <v-card>
          <v-card-title class="headline">
            {{checkDialog.text}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container fluid>
              <v-layout justify-end row>
                <v-btn class="primary" dark text  @click="checkDialog.confirm">確定</v-btn>
              </v-layout>
              <v-checkbox class="title" v-model="editedItem.isWork8month" :label="'正職是否滿8個月'"></v-checkbox>
              <hr class="mb-2">
              <v-layout v-for="(item, i) in getRequireCheckList" :key="item.key">
                <v-flex xs12>
                  <span class="title">{{item.title}}</span>
                  <v-checkbox class="title" v-model="requireOption[i].value" :label="item.text"></v-checkbox>
                </v-flex>
              </v-layout>
              <hr>
              <v-layout row wrap v-for="item in getCheckList" :key="item.key">
                <v-flex xs12>
                  <span class="title">{{item.title}}</span>
                  <v-checkbox class="title" v-if="requireOption[0].value === true && item.key ===  6" :label="item.text" disabled></v-checkbox>
                  <v-checkbox class="title" v-else-if="requireOption[1].value === true && item.key === 3" :label="item.text" disabled></v-checkbox>
                  <v-checkbox class="title" v-else-if="editedItem.vendor.productId === '1' && item.key === 8" :label="item.text" disabled></v-checkbox>
                  <v-checkbox class="title" v-else-if="editedItem.vendor.productId === '2' && item.key === 9" :label="item.text" disabled></v-checkbox>
                  <v-checkbox class="title" v-else v-model="item.value" :label="item.text"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary" dark text  @click="checkDialog.confirm">確定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div><!--wrapper-->
  </div>
</v-app>
</template>

<script>


import MobileDetect from "mobile-detect";
import { mapActions, mapGetters } from "vuex";
import dateTimeTool from "@/components/dateTimeTool";
import DrawCanvas from "@/components/DrawCanvas";
import UploadView from "@/components/UploadView";
import ApplicationModel from "../../models/ApplicationModel";
import UseCaseView from "../../components/UseCaseView";
import {
  getCaInstallmentsNumber,
  getCaCreditPriceMonth,
  getCaTotalCreditPrice,
} from "@/pages/utils/CreditRuleTools";
import AlertView from "@/components/AlertView";
import common from '../../mixins/common';

const md = new MobileDetect(window.navigator.userAgent);

export default {
  name: "EditCAProductView",
  props: {
    loading: Boolean,
    isSaveSuccess: Boolean,
    platform: Number, //0裕富 3高踞
  },
  components: { dateTimeTool, DrawCanvas, UploadView, UseCaseView, AlertView },
  data() {
    return {
      requireOption:[{
        value: false,
      },
        {
          value: false,
        }],
      loadingInfo: this.loading,
      editedIndex: -1,
      editedItem: null,
      defaultItem: new ApplicationModel(),
      creditPriceData: require("../../assets/commodity_bonus"),
      signDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      dateInfoDialog: {
        key: "",
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      checkDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      checkDialog5: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      signKey: "customer",
      productList: [],
      promotion: {},
      promotionRule: {},
      baseScore: {},
      priceData: require("../../assets/finance_bonus_AA21"),
      isNew: false,
      isFinance: false,
      category:0,
      condition:0,
      taiwanCityList: [],
      areaList: {},
      cityData: require('../../assets/taiwan_city'),
      attachmentFile: {
        attachmentFiles:[],
      },
    };
  },
  created() {
    this.editedIndex = this.$route.query.editIndex;
    this.isFinance = !!parseInt(this.$route.query.isFinance);
    this.category = parseInt(this.$route.query.caseCategory, 10);
    this.isNew = !!parseInt(this.$route.query.isNew);

    this.cityData.taiwan.forEach((city) => {
        this.taiwanCityList.push(city.city);
        this.areaList[city.city] = city.area;
    });

    if (!this.platform) {
      this.platform = 0;
    }
    if (this.editedIndex === 0 || parseInt(this.editedIndex, 10) === 0) {
      // 編輯
      if (this.platform === 0 && this.isFinance) {
        this.fetchCreditProductInfo({ caseId: this.$route.query.caseId }).then(
          (results) => {
            this.sortLoadData(results);
          }
        );
      } else {
        this.caInfo({ caseId: this.$route.query.caseId }).then((results) => {
          this.sortLoadData(results);
        });
      }
    } else {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.caseId = Math.uuidFast();
      this.editedItem.displayId = this.$route.query.caseId;
      this.editedItem.category = this.category;

      const now = new Date();
      this.defaultItem.applyDate.year = `${now.getFullYear() - 1911}`;
      this.defaultItem.applyDate.month = `${
        now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1
      }`;
      this.defaultItem.applyDate.day = `${
        now.getDate() + 1 < 10 ? `0${now.getDate()}` : now.getDate()
      }`;
      this.editedItem.vendor.totalPrice =
        this.editedItem.vendor.totalPrice == 0
          ? 200000
          : this.editedItem.vendor.totalPrice;
      console.log(`this.platform  ${this.platform}`);
      this.editedItem.vendor.productName = "機車N";
      if (this.platform === 0) {
        this.initYurich();
      } else {
        this.loadCaseRule();
      }
    }

    if (this.getAgentInfo) {
      if (this.getAgentInfo.enableFinanceAgent) {
        this.editedItem.vendor.salesCellphone = this.getAgentInfo.financePhone;
        this.editedItem.vendor.signature = this.getAgentInfo.financeName;
      }
    }
  },
  mixins:[common],
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList", "getAgentInfo"]),
    checkCaseType(){
      if (!!this.editedItem.header.caseType4 || this.editedItem.header.type[1].value) {
        return true
      }
      if(this.editedItem.vendor.productId === '3'){
        this.editedItem.header.caseType = ''
        return true;
      } else {
        return false;
      }
    },
    checkCaseType4(){
      if (!!this.editedItem.header.caseType || this.editedItem.header.type[1].value) {
        return true
      }
      if(this.editedItem.vendor.productId === '1'){
        this.editedItem.header.caseType4 = ''
        return true;
      } else {
        return false;
      }
    },
    hasAttachmentFile(){
      return this.attachmentFile.attachmentFiles.length > 0;
    },
    canCustomPrice() {
      if (
        this.getAgentInfo.enableEditPrice === true ||
        this.isAdmin
      ) {
        return true;
      }
      return false;
    },
    getCreditPriceList() {
      const list = [];
      let end = 250000;
      if (this.condition < 3 && this.editedItem.header.caseType5 === ''){
        end = 150000;
      }
      for (let i = 30000; i <= end; i += 10000) {
        list.push(i);
      }
      return list;
    },
    getInstallmentsNumberList() {
      let numberList = []; // [12, 15, 18, 20, 24];
      if (
        !!this.promotionRule &&
        Object.keys(this.promotionRule).length > 0 &&
        this.platform === 0
      ) {
        numberList = this.promotionRule["installments"];
      } else {
        if (this.editedItem.header.caseType5 !== ''){
          numberList = getCaInstallmentsNumber(3);
        } else {
          let selectValue = !this.editedItem.header.caType[0].value ? 1 : 0
          numberList = getCaInstallmentsNumber(selectValue);
        }
      }
      return numberList;
    },
    isAdmin() {
      return this.getUserInfo.authority === "admin";
    },
    yearList() {
      const start = new Date().getFullYear();
      const end = 1911;
      const list = [];
      for (let i = start; i >= end; i--) {
        list.push({ key: `${i - 1911}`, name: `${i - 1911}` });
      }
      return list;
    },
    monthList() {
      return [
        { name: "01", key: "01" },
        { name: "02", key: "02" },
        { name: "03", key: "03" },
        { name: "04", key: "04" },
        { name: "05", key: "05" },
        { name: "06", key: "06" },
        { name: "07", key: "07" },
        { name: "08", key: "08" },
        { name: "09", key: "09" },
        { name: "10", key: "10" },
        { name: "11", key: "11" },
        { name: "12", key: "12" },
      ];
    },
    dayList() {
      const startIndex = 1;
      const list = [];
      for (let i = startIndex; i <= 31; i++) {
        if (i < 10) {
          list.push({ key: `0${i}`, name: `0${i}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      return list;
    },
    relationshipList() {
      return [
        { key: 1, name: "配偶" },
        { key: 2, name: "父母" },
        { key: 3, name: "兄弟姐妹" },
        { key: 4, name: "其他親友" },
        { key: 5, name: "同事" },
        { key: 6, name: "朋友" },
        { key: 7, name: "子女" },
        { key: 8, name: "其他" },
      ];
    },
    cityList() {
      return [
        { key: "10001", name: "北縣" },
        { key: "10002", name: "宜縣" },
        { key: "10003", name: "桃縣" },
        { key: "10004", name: "竹縣" },
        { key: "10005", name: "苗縣" },
        { key: "10006", name: "中縣" },
        { key: "10007", name: "彰縣" },
        { key: "10008", name: "投縣" },
        { key: "10009", name: "雲縣" },
        { key: "10010", name: "嘉縣" },
        { key: "10011", name: "南縣" },
        { key: "10012", name: "高縣" },
        { key: "10013", name: "屏縣" },
        { key: "10014", name: "東縣" },
        { key: "10015", name: "花縣" },
        { key: "10016", name: "澎縣" },
        { key: "10017", name: "基市" },
        { key: "10018", name: "竹市" },
        { key: "10020", name: "嘉市" },
        { key: "09007", name: "連江" },
        { key: "09020", name: "金門" },
        { key: "63000", name: "北市" },
        { key: "64000", name: "高市" },
        { key: "65000", name: "新北市" },
        { key: "66000", name: "中市" },
        { key: "67000", name: "南市" },
        { key: "68000", name: "桃市" },
      ];
    },
    isDisablePlus() {
      return (this.platform === 3 || (this.platform === 0 && !this.editedItem.header.caseType)) && !this.isFinance;
    },
  },
  methods: {
    ...mapActions([
      "fetchFinanceCreditList",
      "saveFinanceCreditData",
      "removeFinanceCreditData",
      "fetchAgentList",
      "uploadImageData",
      "caseRuleInfo",
      "caInfo",
      "fetchCreditProductInfo",
      'getFinanceOfficialData'
    ]),
    async sortLoadData(results) {
      console.log(`sortLoadData === ${JSON.stringify(results)}`);
      if (results.length === 0) {
        // 重複
        this.showMessageDialog(
          "錯誤",
          "查無資料",
          true,
          () => {},
          () => {}
        );
      } else {
        this.editedItem = (this.platform === 0 && this.isFinance) ? results[0] : results.data.data;

        if (
          this.editedItem.vendor.productName === "原車" &&
          this.editedItem.category === 0
        ) {
          this.editedItem.vendor.productName = "冷氣";
        } else {
          this.editedItem.vendor.productName = "機車";
        }
        if (!this.editedItem.vendor.signature) {
          this.editedItem.vendor.signature = "";
        }

        this.editedItem.vendor.totalPrice =
          this.editedItem.vendor.totalPrice === 0
            ? 200000
            : this.editedItem.vendor.totalPrice;
        if (!this.editedItem.customer.birthdayInfo) {
          this.$set(this.editedItem.customer, "birthdayInfo", {
            year: "",
            month: "",
            day: "",
            isRepublic: true,
            startCount: 0,
          });
        }
        if (!this.editedItem.signImage0) {
          this.editedItem.signImage0 = null;
        }
        if (!this.editedItem.signImage1) {
          this.editedItem.signImage1 = null;
        }
        if (!this.editedItem.signImage2) {
          this.editedItem.signImage2 = null;
        }
        if (!this.editedItem.signImage0Url) {
          this.editedItem.signImage0Url = null;
        }
        if (!this.editedItem.signImage1Url) {
          this.editedItem.signImage1Url = null;
        }
        if (!this.editedItem.signImage2Url) {
          this.editedItem.signImage2Url = null;
        }
      }
      if (this.isNew && (
        this.editedItem.header.caseType || this.editedItem.header.type[1].value || this.editedItem.header.caseType4 || this.editedItem.header.caseType5)) {
        this.editedItem.header.caType[0].value = true;
        this.editedItem.header.caseType4 = '';
        this.editedItem.header.caseType5 = '';
      }

      console.log(`1 ${this.editedItem.header.caType[0].value} 1 ${!!this.editedItem.header.caseType4} 2 ${this.editedItem.header.caType[2].value}`)

      if(!!this.editedItem.header.caseType4) { // 優質
        this.condition = 1;
      } else if (!!this.editedItem.header.caType[2].value) { // 一般
        this.condition = 2;
      } else if(!!this.editedItem.header.caseType5) { // 超優
        this.condition = 3;
      }

      const result = await this.getFinanceOfficialData({ caseId: this.editedItem.caseId });
      if (result){
        this.attachmentFile = result;
        console.log(`attachmentFile ${JSON.stringify(this.attachmentFile)}`);
      }

      if (this.platform === 0) {
        this.initYurich();
        this.loadingInfo = false;
      } else {
        this.loadCaseRule();
      }

    },
    checkCondition(value) {
      // 1 優質 2 一般 3 超優
      this.condition = value;
      const isChecked = !this.editedItem.header.caType[value].value;
      for (let i = 0; i < 3; i++) {
        this.editedItem.header.caType[i].value = false;
      }

      this.editedItem.header.caType[value].value = isChecked;

      if (value !== 1) {
        this.editedItem.header.caseType4 = "";
      }
      if (value !== 3) {
        this.editedItem.header.caseType5 = "";
      }

      this.changeInstallmentsNumber();
    },
    initYurich() {
      this.loadingInfo = false;
      const code = "";
      if (this.platform === 0) {
        if(this.editedItem.vendor.creditPriceMonth === 0) {
          this.changeInstallmentsNumber();
        } else {
          this.checkTotalCreditPrice()
        }
      } else {
        this.baseScore = this.creditPriceData[value];
        this.businessTypeProjects(code, 0);
      }
    },
    businessTypeProjects(code, index) {
      this.promotion = {};
      this.promotionRule = {};

      if (code && this.platform === 0) {
        const tempPromotion = this.productList[index]["promotion_no"].filter(
          (item) => item.code === code
        );
        if (tempPromotion.length > 0) {
          this.promotion = tempPromotion[0];
        }

        const tempPromotionRule = this.productList[index]["rule"].filter(
          (item) => item.code === code
        );
        if (tempPromotionRule.length > 0) {
          this.promotionRule = tempPromotionRule[0];
        }
      }
      const isEmpty = Object.keys(this.promotionRule).length;
      const costMax =
        this.platform === 0 || !isEmpty
          ? 200000
          : this.promotionRule["cost_max"];

      if (this.platform === 3) {
        this.editedItem.vendor.totalPrice = code ? costMax : 200000;
      }
      const productCode =
        this.platform === 0 || !isEmpty
          ? ""
          : this.productList[index]["product_code"];
      this.editedItem.useCase.cardless_code = code ? productCode : "";
      this.editedItem.useCase.supplier_business_type = code ? "CA20" : "";
      this.editedItem.useCase.supplier_business_type_projects = code
        ? code
        : "";
      this.changeInstallmentsNumber();
    },
    changeInstallmentsNumber() {
      const find =
        this.platform === 0
          ? this.creditPriceData[this.condition][this.editedItem.vendor.installmentsNumber][0]
          : this.baseScore[this.editedItem.vendor.installmentsNumber];
      if (find) {
        let price = 0;
        if (this.platform === 0) {
          price = find.monthPrice * (this.editedItem.vendor.totalPrice / 10000);
        } else {
          const scoreItem = find[0];
          const multipleValue = this.editedItem.vendor.totalPrice / 10000;
          price = scoreItem.monthPrice * multipleValue;
        }

        this.editedItem.vendor.creditPriceMonth = parseInt(price);
        this.editedItem.vendor.totalCreditPrice =
          parseInt(this.editedItem.vendor.installmentsNumber) *
          parseInt(this.editedItem.vendor.creditPriceMonth);
      }
    },
    checkTotalCreditPrice(){
       this.editedItem.vendor.totalCreditPrice =
          parseInt(this.editedItem.vendor.installmentsNumber) *
          parseInt(this.editedItem.vendor.creditPriceMonth);
    },
    signImageSrc(itemPath) {
      let source = null;
      if (itemPath === "signImage1") {
        if (this.editedItem.signImage1) {
          source = this.editedItem.signImage1;
        } else if (this.editedItem.signImage1Url) {
          source = this.editedItem.signImage1Url;
        }
      } else if (itemPath === "signImage2") {
        if (this.editedItem.signImage2) {
          source = this.editedItem.signImage2;
        } else if (this.editedItem.signImage2Url) {
          source = this.editedItem.signImage2Url;
        }
      } else if (itemPath === "signImage3") {
        if (this.editedItem.signImage3) {
          source = this.editedItem.signImage3;
        } else if (this.editedItem.signImage3Url) {
          source = this.editedItem.signImage3Url;
        }
      }
      return source;
    },
    checkHomeType() {
      if (this.editedItem.customer.home.homeType1[0].value) {
        this.editedItem.customer.home.homePost = this.editedItem.customer.home.residencePost;
        this.editedItem.customer.home.homeCity = this.editedItem.customer.home.residenceCity;
        this.editedItem.customer.home.homeArea = this.editedItem.customer.home.residenceArea;
        this.editedItem.customer.home.homeAddress1 = this.editedItem.customer.home.residenceAddress;
      } else {
        this.editedItem.customer.home.homePost = '';
        this.editedItem.customer.home.homeCity = '';
        this.editedItem.customer.home.homeArea = '';
        this.editedItem.customer.home.homeAddress1 = '';
      }
    },
    checkCreditcardStatus(value) {
      const isChecked = this.editedItem.bank.type[value].value;

      const callback = (item, index) => {
        item.value = false;
      };
      this.editedItem.bank.type.forEach(callback);
      this.editedItem.bank.type[value].value = isChecked;
      if (isChecked) {
        const status = value + 1;
        this.editedItem.useCase.creditcard_status = status;
        if (value === 3) {
          this.editedItem.useCase.creditcard_status_remark = this.editedItem.bank.otherType;
        }
      }
    },
    setOtherType() {
      if (this.editedItem.bank.otherType) {
        const callback = (item, index) => {
          item.value = index === 3;
        };
        this.editedItem.bank.type.forEach(callback);
        this.editedItem.useCase.creditcard_status_remark = this.editedItem.bank.otherType;
      }
      this.editedItem.useCase.creditcard_status_remark = this.editedItem.bank.otherType;
    },
    showDateToolDialog(key) {
      this.dateInfoDialog.key = key;
      this.dateInfoDialog.visible = true;
      this.dateInfoDialog.text = "請選擇日期";
      this.dateInfoDialog.confirm = () => {
        if (key === "birthday") {
          this.editedItem.customer.birthday = `${this.editedItem.customer.birthdayInfo.year}年${this.editedItem.customer.birthdayInfo.month}月${this.editedItem.customer.birthdayInfo.day}日`;
        }
        if (key === "memberIdDate") {
          this.editedItem.customer.memberIdDate = `${this.editedItem.customer.memberIdDateInfo.year}年${this.editedItem.customer.memberIdDateInfo.month}月${this.editedItem.customer.memberIdDateInfo.day}日`;
        }
        if (key === "jointGuarantor.birthday") {
          this.editedItem.jointGuarantor.birthday = `${this.editedItem.jointGuarantor.birthdayInfo.year}年${this.editedItem.jointGuarantor.birthdayInfo.month}月${this.editedItem.jointGuarantor.birthdayInfo.day}日`;
        }
        if (key === "jointGuarantor.memberIdDate") {
          this.editedItem.jointGuarantor.memberIdDate = `${this.editedItem.jointGuarantor.memberIdDateInfo.year}年${this.editedItem.jointGuarantor.memberIdDateInfo.month}月${this.editedItem.jointGuarantor.memberIdDateInfo.day}日`;
        }
        this.dateInfoDialog.visible = false;
      };
    },
    showTip() {
      if (this.firstTipCount < 1) {
        this.firstTipCount += 1;
        this.showMessageDialog(
          "提示",
          "聯絡人一率保密，僅在逾期繳款才會通知聯絡人",
          true,
          () => {},
          () => {}
        );
        setTimeout(() => {
          this.messageDialog.visible = false;
        }, 2500);
      }
    },
    showSecondTip() {
      if (this.secondTipCount < 1) {
        this.secondTipCount += 1;
        this.showMessageDialog(
          "提示",
          "聯絡人一率保密，僅在逾期繳款才會通知聯絡人",
          true,
          () => {},
          () => {}
        );
        setTimeout(() => {
          this.messageDialog.visible = false;
        }, 2500);
      }
    },
    showSignDialog(key) {
      this.signKey = key;
      this.signDialog.visible = true;
    },
    setTypeEvent(type) {
      if (type === 1) {
        const relationshipArray = this.relationshipList.filter(
          (item) => item.key === this.editedItem.firstContact.relationship
        );
        this.editedItem.firstContact.type =
          relationshipArray.length > 0 ? relationshipArray[0].name : "";
      } else if (type === 2) {
        const relationshipArray = this.relationshipList.filter(
          (item) => item.key === this.editedItem.secondContact.relationship
        );
        this.editedItem.secondContact.type =
          relationshipArray.length > 0 ? relationshipArray[0].name : "";
      } else if (type === 2) {
        const relationshipArray = this.relationshipList.filter(
          (item) => item.key === this.editedItem.jointGuarantor.relationship
        );
        this.editedItem.jointGuarantor.type =
          relationshipArray.length > 0 ? relationshipArray[0].name : "";
      }
    },
    setMemberIdCity(type) {
      if (type === 1) {
        // this.editedItem.customer.memberIdCity = this.editedItem.useCase.issue_place
        const cityArray = this.cityList.filter(
          (item) => item.key === this.editedItem.useCase.issue_place
        );
        const cityName = cityArray.length > 0 ? cityArray[0].name : ""

        const newCityArray = this.getMemberIdCityList.filter(
          (item) => item.value === cityName
        )
        this.editedItem.customer.memberIdCity =
          newCityArray.length > 0 ? newCityArray[0].key : "";
      } else if (type === 2) {
        // this.editedItem.jointGuarantor.memberIdCity = this.editedItem.useCase.guarantor_issue_place
        const cityArray = this.getMemberIdCityList.filter(
          (item) => item.key === this.editedItem.useCase.guarantor_issue_place
        );
        const cityName = cityArray.length > 0 ? cityArray[0].name : ""

        const newCityArray = this.getMemberIdCityList.filter(
          (item) => item.value === cityName
        )
        this.editedItem.jointGuarantor.memberIdCity =
          newCityArray.length > 0 ? newCityArray[0].key : "";
      }
    },
    async handleDownloadSign(image) {
      console.log(`handleDownloadSign == ${image}`);
      if (this.signKey === "jointGuarantor") {
        this.editedItem.signImage3 = image;
      } else {
        this.editedItem.signImage0 = image;
        this.editedItem.signImage1 = image;
        this.editedItem.signImage2 = image;
      }

      this.signDialog.visible = false;
      this.signDialog.confirm = () => {
        if (this.signKey === "jointGuarantor") {
          this.editedItem.signImage3 = image;
        } else {
          this.editedItem.signImage0 = image;
          this.editedItem.signImage1 = image;
          this.editedItem.signImage2 = image;
        }
        this.signDialog.visible = false;
      };
    },
    handleDownloadClose() {
      this.signDialog.visible = false;
    },
    checkFormData() {
      this.editedItem.customer.home.residencePost = this.editedItem.customer.home.residencePost.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.residenceCity = this.editedItem.customer.home.residenceCity.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.residenceArea = this.editedItem.customer.home.residenceArea.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.residenceAddress = this.editedItem.customer.home.residenceAddress.replace(/([\r\n])|(<\/?. ?>)/g,'')

      this.editedItem.customer.home.homePost = this.editedItem.customer.home.homePost.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.homeCity = this.editedItem.customer.home.homeCity.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.homeArea = this.editedItem.customer.home.homeArea.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.homeAddress1 = this.editedItem.customer.home.homeAddress1.replace(/([\r\n])|(<\/?. ?>)/g,'')

      if (this.editedItem.customer.name === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫姓名！",
          true,
          () => {},
          () => {}
        );
        return false;
      }

      if(this.editedItem.header.caseType4 === '' && this.editedItem.header.caseType5 === '' && !this.editedItem.header.caType[2].value) {
        this.showMessageDialog(
          "錯誤",
          "請選擇商品條件！",
          true,
          () => {},
          () => {}
        );
        return false;
      }

      if (this.editedItem.vendor.productName === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫商品名稱！",
          true,
          () => {},
          () => {}
        );
        return false;
      }

      if (this.editedItem.customer.cellphone === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫行動電話！",
          true,
          () => {},
          () => {}
        );
        return false;
      } else if (this.editedItem.customer.cellphone) {
        let errorMessage = "";
        if (this.editedItem.customer.cellphone.length !== 10) {
          errorMessage = "行動電話號碼應為10碼！";
        } else if (!/^09\d{8}$/.test(this.editedItem.customer.cellphone)) {
          errorMessage = "行動電話號碼應為09開頭！";
        }

        if (errorMessage) {
          this.showMessageDialog(
            "錯誤",
            errorMessage,
            true,
            () => {},
            () => {}
          );
          return false;
        }
      }

      if (this.editedItem.customer.memberId === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫身分證！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.editedItem.customer.birthday === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫生日！",
          true,
          () => {},
          () => {}
        );
        return false;
      }

      //商品貸需要判斷公司名稱與公司電話，高踞暫時不用
      let errorMessage = "";
      if (!this.editedItem.company.name) {
        errorMessage = "請填寫公司名稱！";
      } else if (!this.editedItem.company.phone) {
        errorMessage = "請填寫公司電話！";
      }
      if (errorMessage) {
        this.showMessageDialog(
          "錯誤",
          errorMessage,
          true,
          () => {},
          () => {}
        );
        return false;
      }
      //商品貸需要判斷第一聯絡人姓名、電話、關係，高踞不用
      if (
        this.editedItem.firstContact.name === "" ||
        this.editedItem.firstContact.cellphone === "" ||
        this.editedItem.firstContact.relationship === 0
      ) {
        this.showMessageDialog(
          "錯誤",
          "請填寫第一聯絡人姓名、關係、電話！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      //商品貸需要判斷商品總價、分期期數、分期金額、分期總額，高踞不用
      if (
        !this.editedItem.vendor.totalPrice ||
        !this.editedItem.vendor.installmentsNumber ||
        !this.editedItem.vendor.creditPriceMonth ||
        !this.editedItem.vendor.totalCreditPrice
      ) {
        this.showMessageDialog(
          "錯誤",
          "請填寫總價、分期期數、分期金額、分期總額！",
          true,
          () => {},
          () => {}
        );
        return false;
      }

      if (this.platform === 0) {
        return true;
      }

      //以下判斷，只有高踞要
      let birthday = new Date(
        parseInt(this.editedItem.customer.birthdayInfo.year) + 1911,
        this.editedItem.customer.birthdayInfo.month,
        this.editedItem.customer.birthdayInfo.day
      );

      var d = new Date();
      var age =
        d.getFullYear() -
        birthday.getFullYear() -
        (d.getMonth() < birthday.getMonth() ||
        (d.getMonth() == birthday.getMonth() &&
          d.getDate() < birthday.getDate())
          ? 1
          : 0);

      const ageMin = this.platform === 0 ? 0 : this.promotionRule["age_min"];
      const ageMax = this.platform === 0 ? 100 : this.promotionRule["age_max"];

      // if (this.editedItem.useCase.issue_place === "") {
      //   this.showMessageDialog(
      //     "錯誤",
      //     "請填寫發證地點！",
      //     true,
      //     () => {},
      //     () => {}
      //   );
      //   return false;
      // }

      if (this.editedItem.customer.home.residencePost === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫戶籍郵遞區號！",
          true,
          () => {},
          () => {}
        );
        return false;
      }

      if (this.editedItem.customer.home.residenceAddress === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫戶籍地址！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.editedItem.customer.home.homePost === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫住宅郵遞區號！",
          true,
          () => {},
          () => {}
        );
        return false;
      }

      if (this.editedItem.customer.home.homeAddress1 === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫住宅地址！",
          true,
          () => {},
          () => {}
        );
        return false;
      }

      // if (this.editedItem.company.name === "") {
      //   this.showMessageDialog(
      //     "錯誤",
      //     "請填寫公司名稱！",
      //     true,
      //     () => {},
      //     () => {}
      //   );
      //   return false;
      // }
      // if (this.editedItem.company.phone === "") {
      //   this.showMessageDialog(
      //     "錯誤",
      //     "請填寫公司電話！",
      //     true,
      //     () => {},
      //     () => {}
      //   );
      //   return false;
      // }
      // console.log( `${this.editedItem.bank.type[0].value }  ==
      //   ${this.editedItem.bank.type[1].value} ===
      //   ${this.editedItem.bank.type[2].value} &&
      //   ${this.editedItem.bank.type[3].value}`)
      // if (
      //   !this.editedItem.bank.type[0].value &&
      //   !this.editedItem.bank.type[1].value &&
      //   !this.editedItem.bank.type[2].value &&
      //   !this.editedItem.bank.type[3].value
      // ) {
      //   this.showMessageDialog(
      //     "錯誤",
      //     "請選擇信用卡狀態！",
      //     true,
      //     () => {},
      //     () => {}
      //   );
      //   return false;
      // } else if (
      //   this.editedItem.bank.type[3].value &&
      //   !this.editedItem.bank.otherType
      // ) {
      //   this.showMessageDialog(
      //     "錯誤",
      //     "請填寫信用卡其他狀態！",
      //     true,
      //     () => {},
      //     () => {}
      //   );
      //   return false;
      // }
      // if (
      //   !this.editedItem.hasJointGuarantor[0].value &&
      //   !this.editedItem.hasJointGuarantor[1].value &&
      //   !this.editedItem.hasJointGuarantor[2].value &&
      //   !this.editedItem.hasJointGuarantor[3].value
      // ) {
      //   this.showMessageDialog(
      //     "錯誤",
      //     "請選擇保證人身分！",
      //     true,
      //     () => {},
      //     () => {}
      //   );
      //   return false;
      // } else {
      //   if (this.editedItem.hasJointGuarantor[0].value) {
      //     this.editedItem.useCase.guarantor_option = 1;
      //   } else if (this.editedItem.hasJointGuarantor[1].value) {
      //     this.editedItem.useCase.guarantor_option = 2;
      //   } else if (this.editedItem.hasJointGuarantor[2].value) {
      //     this.editedItem.useCase.guarantor_option = 3;
      //   } else if (this.editedItem.hasJointGuarantor[3].value) {
      //     this.editedItem.useCase.guarantor_option = 4;
      //   }
      // }

      // if (this.editedItem.secondContact.name === '' || this.editedItem.secondContact.cellphone === ''
      //     || this.editedItem.secondContact.type === '') {
      //   this.showMessageDialog('錯誤', '請填寫第二聯絡人姓名、關係、電話！', true, () => {
      //   }, () => {
      //   });
      //   return false;
      // }
      // if (this.editedItem.jointGuarantor.name !== "") {
      //   let hasCheck = false;
      //   this.editedItem.hasJointGuarantor.forEach((item) => {
      //     if (item.value === true) {
      //       hasCheck = true;
      //     }
      //   });
      //   if (!hasCheck) {
      //     this.showMessageDialog(
      //       "錯誤",
      //       "請勾選保證人的選項！",
      //       true,
      //       () => {},
      //       () => {}
      //     );
      //     return false;
      //   }
      // }

      // if (!this.editedItem.customer.home.residencePost) {
      //   this.showMessageDialog(
      //     "錯誤",
      //     "請填戶籍地的郵遞區號！",
      //     true,
      //     () => {},
      //     () => {}
      //   );
      //   return false;
      // }
      // if (!this.editedItem.customer.home.homePost) {
      //   this.showMessageDialog(
      //     "錯誤",
      //     "請填住宅地的郵遞區號",
      //     true,
      //     () => {},
      //     () => {}
      //   );
      //   return false;
      // }

      if (this.platform === 0) {
        if (!this.editedItem.bankId || !this.editedItem.bankSubId) {
          this.showMessageDialog(
            "錯誤",
            "請填撥款銀行帳戶！",
            true,
            () => {},
            () => {}
          );
          return false;
        }

        if (
          Object.keys(this.promotion).length === 0 ||
          Object.keys(this.promotionRule).length === 0
        ) {
          this.showMessageDialog(
            "錯誤",
            "請選擇貸款條件！",
            true,
            () => {},
            () => {}
          );
          return false;
        }
        if (age < ageMin || age > ageMax) {
          this.showMessageDialog(
            "錯誤",
            `申請年齡只能 ${ageMin} 到 ${ageMax} 歲區間！`,
            true,
            () => {},
            () => {}
          );
          return false;
        }
        const costMax =
          this.platform === 0 ? 200000 : this.promotionRule["cost_max"];
        if (this.editedItem.vendor.totalPrice > costMax) {
          this.showMessageDialog(
            "錯誤",
            `商品總價不得大於 ${costMax} 元！`,
            true,
            () => {},
            () => {}
          );
          return false;
        }
        if (!this.editedItem.files.length) {
          this.showMessageDialog(
            "錯誤",
            "請上傳貸款文件相關圖檔！",
            true,
            () => {},
            () => {}
          );
          return false;
        } else if (this.editedItem.files.length > 0) {
          let message = "";
          const codeArray = ["LDR1", "LDR2", "LDR3"];
          codeArray.forEach((name) => {
            const index = this.editedItem.files
              .map(function (e) {
                return e.key;
              })
              .indexOf(name);
            if (index > -1) {
              if (name === "LDR1") {
                message = "申請人身分證正面";
              } else if (name === "LDR2") {
                message = "申請人身分證反面";
              } else if (name === "LDR2") {
                message = "申請人身撥款帳戶存摺封面";
              }
            }
          });

          if (message.length > 0) {
            message = "請上傳" + message + "文件 ！";
            this.showMessageDialog(
              "錯誤",
              message,
              true,
              () => {},
              () => {}
            );
            return false;
          }
        }
      }
      return true;
    },
    showCheckDialog(type) {
      console.log(`caseType ${this.editedItem.header.caseType} caseType4 ${this.editedItem.header.caseType4}`)
      const typeText = type === 0 ? '請選擇優加符合項目' : '請選擇優質符合項目'
      this.checkDialog.visible = true;
      this.checkDialog.text = typeText;
      this.checkDialog.confirm = () => {
        // console.log(JSON.stringify(this.getCheckList));
        const checkRequireCount = this.requireOption.filter(m=>m.value === true);
        const checkCount = this.getCheckList.filter(m=>m.value === true);
        console.log(`checkCount == ${checkRequireCount.length} / ${checkCount.length} / ${this.editedItem.vendor.productId} | ${this.getCheckList[0].value}`);
        this.editedItem.header.caseType5 = '';
        this.editedItem.header.caseType = '';
        this.editedItem.header.caseType4 = '';
        let i = 0;
        let requireContent = '';
        for (let option of this.getRequireCheckList){
          if (this.requireOption[i].value){
            requireContent += `${option.option} `;
          }
          i++;
        }
        if (checkRequireCount.length === 0 && checkCount.length === 1){ // 優質專案
          for (let item of this.getCheckList){
            if (item.value) {
              requireContent += `${item.key + 1} `;
            }
          }
          this.editedItem.header.caseType4 += requireContent;
        } else if (checkRequireCount.length === 0 && checkCount.length > 1 && this.getCheckList[0].value === false){ // 優質專案
          for (let item of this.getCheckList){
            if (item.value) {
              requireContent += `${item.key + 1} `;
            }
          }
          this.editedItem.header.caseType4 += requireContent;
        }  else if (checkRequireCount.length > 0  || (checkCount.length > 1 && this.getCheckList[0].value === true)){ // 優加專案
          for (let item of this.getCheckList){
            if (item.value) {
              requireContent += `${item.key + 1} `;
            }
          }
          if (checkRequireCount.length > 0){
            this.editedItem.header.caseType5 += requireContent;
          } else {
            this.editedItem.header.caseType4 += requireContent;
          }
        }
        this.checkDialog.visible = false;
      };
    },
    updateData() {
      if (!this.editedItem.company.workYear) {
        this.editedItem.company.workYear = 0;
      }
      if (!this.editedItem.company.workMonth) {
        this.editedItem.company.workMonth = 0;
      }
      if (!this.editedItem.company.salary) {
        this.editedItem.company.salary = 0;
      }
      if (!this.editedItem.platform) {
        this.editedItem.platform = this.platform;
      }
      if (this.editedItem.platform !== this.platform) {
        this.editedItem.platform = this.platform;
      }
      this.editedItem.category = 2;
    },
    save() {
      if (this.checkFormData()) {
        this.updateData();
        console.log(`save ca info === ${JSON.stringify(this.editedItem)}`);
        this.$emit("saveData", this.editedItem);
      }
    },
    changeEvent(item) {
      this.editedItem.laonhfcInfo = item.itemInfo;
      this.editedItem.bankId = item.bankId;
      this.editedItem.bankSubId = item.bankSubId;
      this.editedItem.bankAccount = item.bankAccount;
      this.editedItem.useCase.employment_status = item.employment_status;
    },
    uploadEvent(items) {
      this.editedItem.files = items;
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    loadJsonRule() {
      this.loadingInfo = true;
      this.loadingInfo = false;
    },
    async loadCaseRule() {
    },
    changeResidenceInfo(){
      this.editedItem.customer.home.residenceCity = this.editedItem.customer.home.residenceCity.replace(/([ ])|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.residenceArea = this.editedItem.customer.home.residenceArea.replace(/([ ])|([\r\n])|(<\/?. ?>)/g,'')
      if(this.editedItem.customer.home.residenceCity !== "" && this.editedItem.customer.home.residenceArea) {
        const city = this.editedItem.customer.home.residenceCity;
        const area = this.editedItem.customer.home.residenceArea
        const tempList = this.areaList[city]
        const areaArray = tempList.filter(m => m.text === area);
        if(areaArray.length > 0) {
          const areaInfo = areaArray[0]
          this.editedItem.customer.home.residencePost = areaInfo.zip
        }
      }
    },
    changeHomeInfo() {
      this.editedItem.customer.home.homeCity = this.editedItem.customer.home.homeCity.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.homeArea = this.editedItem.customer.home.homeArea.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')
      console.log(``)
      if(this.editedItem.customer.home.homeCity !== "" && this.editedItem.customer.home.homeArea) {
        const city = this.editedItem.customer.home.homeCity;
        const area = this.editedItem.customer.home.homeArea
        const tempList = this.areaList[city]
        const areaArray = tempList.filter(m => m.text === area);
        if(areaArray.length > 0) {
          const areaInfo = areaArray[0]
          this.editedItem.customer.home.homePost = areaInfo.zip
        }
      }
    },
  },
};
</script>

<style scoped src="../../assets/css/ca_product_view.css">
</style>

<style scoped>
table.blueTable1 td,
table.blueTable2 td,
table.blueTable3 td,
table.blueTable4 td,
table.blueTable5 td,
table.blueTable6 td,
table.blueTable7 td,
table.blueTable8 td,
table.blueTable9 td,
table.blueTable10 td {
  padding: 0 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/EditCAProductView.vue